import type { WorkflowBlock, WorkflowNodeData } from './types';
import { DEFAULT_FRIENDLY_SCHEDULE, scheduleToCron } from './schedule-cron';

const ACTION_BLOCK_KEYS = new Set([
  'send-email',
  'send-notification',
  'create-task',
  'generate-report',
  'data-loader',
]);

/**
 * Pre-fill a node's config based on the palette block it was created from, so a
 * dropped block already has its type-specific settings (trigger type, action
 * type, sensible condition defaults) instead of an empty config.
 */
export function buildConfigForBlock(block: WorkflowBlock): Record<string, unknown> {
  switch (block.type) {
    case 'trigger':
      if (block.blockKey === 'scheduled') {
        return {
          triggerType: 'scheduled',
          cron: scheduleToCron(DEFAULT_FRIENDLY_SCHEDULE),
        };
      }
      return { triggerType: block.blockKey, processingMode: 'per-event' };
    case 'action':
      if (block.blockKey === 'data-loader') {
        return { actionType: 'data-loader', source: 'employees', outputKey: 'data' };
      }
      return ACTION_BLOCK_KEYS.has(block.blockKey) ? { actionType: block.blockKey } : {};
    case 'condition':
      if (block.blockKey === 'salary-threshold') {
        return { field: 'salaryVariance', operator: 'greaterThan', value: '10' };
      }
      return {};
    case 'ai':
      return { outputStyle: 'summary' };
    default:
      return {};
  }
}

export function blockToNodeData(block: WorkflowBlock): WorkflowNodeData {
  return {
    type: block.type,
    label: block.label,
    description: block.description,
    config: buildConfigForBlock(block),
  };
}
